var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var IDENT = '[\\w-]+';
var SPACE = '[ \t]*';
var VALUE = "[^\\]]+";
var CLASS = "(?:\\." + IDENT + ")";
var ID = "(?:#" + IDENT + ")";
var OP = "(?:=|\\$=|\\^=|\\*=|~=|\\|=)";
var ATTR = "(?:\\[" + SPACE + IDENT + SPACE + "(?:" + OP + SPACE + VALUE + SPACE + ")?\\])";
var SUBTREE = "(?:[ \t]+)";
var CHILD = "(?:" + SPACE + "(>)" + SPACE + ")";
var NEXT_SIBLING = "(?:" + SPACE + "(\\+)" + SPACE + ")";
var SIBLING = "(?:" + SPACE + "(~)" + SPACE + ")";
var COMBINATOR = "(?:" + SUBTREE + "|" + CHILD + "|" + NEXT_SIBLING + "|" + SIBLING + ")";
var CONTAINS = "contains\\(\"[^\"]*\"\\)";
var FORMULA = "(?:even|odd|\\d*(?:-?n(?:\\+\\d+)?)?)";
var NTH_CHILD = "nth-child\\(" + FORMULA + "\\)";
var PSEUDO = ":(?:first-child|last-child|" + NTH_CHILD + "|empty|root|" + CONTAINS + ")";
var TAG = "(:?" + IDENT + ")?";
var TOKENS = CLASS + "|" + ID + "|" + ATTR + "|" + PSEUDO + "|" + COMBINATOR;
var combinatorRegex = new RegExp("^" + COMBINATOR + "$");
/**
 * Parses a css selector into a normalized object.
 * Expects a selector for a single element only, no `>` or the like!
 */

export function parseSelector(selector) {
  var sel = selector.trim();
  var tagRegex = new RegExp(TAG, 'y');
  var tag = tagRegex.exec(sel)[0];
  var regex = new RegExp(TOKENS, 'y');
  regex.lastIndex = tagRegex.lastIndex;
  var matches = [];
  var nextSelector = undefined;
  var lastCombinator = undefined;
  var index = -1;

  while (regex.lastIndex < sel.length) {
    var match = regex.exec(sel);

    if (!match && lastCombinator === undefined) {
      throw new Error('Parse error, invalid selector');
    } else if (match && combinatorRegex.test(match[0])) {
      var comb = combinatorRegex.exec(match[0])[0];
      lastCombinator = comb;
      index = regex.lastIndex;
    } else {
      if (lastCombinator !== undefined) {
        nextSelector = [getCombinator(lastCombinator), parseSelector(sel.substring(index))];
        break;
      }

      matches.push(match[0]);
    }
  }

  var classList = matches.filter(function (s) {
    return s.startsWith('.');
  }).map(function (s) {
    return s.substring(1);
  });
  var ids = matches.filter(function (s) {
    return s.startsWith('#');
  }).map(function (s) {
    return s.substring(1);
  });

  if (ids.length > 1) {
    throw new Error('Invalid selector, only one id is allowed');
  }

  var postprocessRegex = new RegExp("(" + IDENT + ")" + SPACE + "(" + OP + ")?" + SPACE + "(" + VALUE + ")?");
  var attrs = matches.filter(function (s) {
    return s.startsWith('[');
  }).map(function (s) {
    return postprocessRegex.exec(s).slice(1, 4);
  }).map(function (_a) {
    var attr = _a[0],
        op = _a[1],
        val = _a[2];
    return _b = {}, _b[attr] = [getOp(op), val ? parseAttrValue(val) : val], _b;

    var _b;
  }).reduce(function (acc, curr) {
    return __assign({}, acc, curr);
  }, {});
  var pseudos = matches.filter(function (s) {
    return s.startsWith(':');
  }).map(function (s) {
    return postProcessPseudos(s.substring(1));
  });
  return {
    id: ids[0] || '',
    tag: tag,
    classList: classList,
    attributes: attrs,
    nextSelector: nextSelector,
    pseudos: pseudos
  };
}

function parseAttrValue(v) {
  if (v.startsWith('"')) {
    return v.slice(1, -1);
  }

  if (v === "true") {
    return true;
  }

  if (v === "false") {
    return false;
  }

  var f = parseFloat(v);

  if (isNaN(f)) {
    return v;
  }

  return f;
}

function postProcessPseudos(sel) {
  if (sel === 'first-child' || sel === 'last-child' || sel === 'root' || sel === 'empty') {
    return [sel, undefined];
  }

  if (sel.startsWith('contains')) {
    var text = sel.slice(10, -2);
    return ['contains', text];
  }

  var content = sel.slice(10, -1);

  if (content === 'even') {
    content = '2n';
  }

  if (content === 'odd') {
    content = '2n+1';
  }

  return ['nth-child', content];
}

function getOp(op) {
  switch (op) {
    case '=':
      return 'exact';

    case '^=':
      return 'startsWith';

    case '$=':
      return 'endsWith';

    case '*=':
      return 'contains';

    case '~=':
      return 'whitespace';

    case '|=':
      return 'dash';

    default:
      return 'has';
  }
}

function getCombinator(comb) {
  switch (comb.trim()) {
    case '>':
      return 'child';

    case '+':
      return 'nextSibling';

    case '~':
      return 'sibling';

    default:
      return 'subtree';
  }
}